import { IRationComponents } from 'models/IRationSystem'
import axAPI from '../httpConfig'

export default class RationsApiService {
	static postNewRation = async (data: {
		title: string
		components: IRationComponents[]
		group_ids?: number[]
		food_humidity?: number
	}) => {
		return axAPI({
			method: 'POST',
			url: `/ration/`,
			data: data,
		})
	}
	static patchCurrentRation = async (data: {
		title: string
		components: IRationComponents[]
		id: number
		food_humidity: number
		group_ids?: number[]
		archive_title?: string
	}) => {
		return axAPI({
			method: 'PATCH',
			url: `/ration/${data.id}`,
			data: {
				title: data.title,
				components: data.components,
				food_humidity: data.food_humidity,
				group_ids: data.group_ids,
				...(data.archive_title ? { archive_title: data.archive_title } : {}),
			},
		})
	}
	static activateRationVersion = async (
		rationId: number,
		versionId: number,
	) => {
		return axAPI({
			method: 'POST',
			url: `/ration/${rationId}/versions/${versionId}/set-active`,
		})
	}
	static deleteRationById = async id => {
		return axAPI({
			method: 'DELETE',
			url: `/ration/${id}`,
		})
	}
	static patchComponent = async (id, data) => {
		return axAPI({
			method: 'PATCH',
			url: `/ration/components/${id}`,
			data: data,
		})
	}
}
